import React from 'react';
import './questions-block-answers.scss';
import { QuestionsBlock } from '/react4xp/parts/questions-block/questions-block.type';
import { Col, Row } from 'antd';
import { localize } from 'mixins/helpers';

function QuestionsBlockAnswers(props: QuestionsBlock.Props) {
    const FALLBACK_TEXT = 'Часто задаваемые вопросы по Налоговому кодексу';

    const raw = localize('any-questions-answers', props.translations);

    const title = !raw || raw === 'any-questions-answers' ? FALLBACK_TEXT : raw;

    const lang = (props.language || props.lang || 'ru').toLowerCase();

    const handleClick = () => {
        window.location.href = `/${lang}/pages/questions-answers`;
    };

    return (
        <div
            className="questions-block clickable"
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleClick()}
        >
            <Row
                gutter={[16, 16]}
                align="middle"
            >
                <Col
                    xs={24}
                    md={16}
                    className="question"
                >
                    {title}
                </Col>
            </Row>
        </div>
    );
}

export default QuestionsBlockAnswers;
